module.exports = __webpack_public_path__ + "img/verlichting2.d38ea458.jpeg";